export const REGISTRATION = {
  GB: 'registration possible',
  ES: 'empadronamiento',
  DE: 'anmeldung',
  IT: 'certificato di residenza',
  FR: 'certificat d’immatriculation',
  PT: 'certificado de registo'
};
